var map = {
	"./da/SDG-1.svg": "2c8e",
	"./da/SDG-10.svg": "f026",
	"./da/SDG-11.svg": "828a",
	"./da/SDG-12.svg": "84c6",
	"./da/SDG-13.svg": "795f",
	"./da/SDG-14.svg": "163c",
	"./da/SDG-15.svg": "0960",
	"./da/SDG-16.svg": "eac1",
	"./da/SDG-17.svg": "52da",
	"./da/SDG-2.svg": "26e2",
	"./da/SDG-3.svg": "9b3a",
	"./da/SDG-4.svg": "5649",
	"./da/SDG-5.svg": "06c3",
	"./da/SDG-6.svg": "5371",
	"./da/SDG-7.svg": "0932",
	"./da/SDG-8.svg": "f240",
	"./da/SDG-9.svg": "7ac9",
	"./en/SDG-1.svg": "2c80",
	"./en/SDG-10.svg": "9403",
	"./en/SDG-11.svg": "0e53",
	"./en/SDG-12.svg": "da47",
	"./en/SDG-13.svg": "ba74",
	"./en/SDG-14.svg": "0e91",
	"./en/SDG-15.svg": "ba24",
	"./en/SDG-16.svg": "1098",
	"./en/SDG-17.svg": "392b",
	"./en/SDG-2.svg": "3b80",
	"./en/SDG-3.svg": "7980",
	"./en/SDG-4.svg": "3827",
	"./en/SDG-5.svg": "b0a6",
	"./en/SDG-6.svg": "1540",
	"./en/SDG-7.svg": "3aad",
	"./en/SDG-8.svg": "2dab",
	"./en/SDG-9.svg": "b183",
	"./fr/SDG-1.svg": "1a27",
	"./fr/SDG-10.svg": "5fa1",
	"./fr/SDG-11.svg": "1a44",
	"./fr/SDG-12.svg": "b7ac",
	"./fr/SDG-13.svg": "68a0",
	"./fr/SDG-14.svg": "bd69",
	"./fr/SDG-15.svg": "94a6",
	"./fr/SDG-16.svg": "5839",
	"./fr/SDG-17.svg": "5deb",
	"./fr/SDG-2.svg": "7ac5",
	"./fr/SDG-3.svg": "80a7",
	"./fr/SDG-4.svg": "bc92",
	"./fr/SDG-5.svg": "ec3c",
	"./fr/SDG-6.svg": "0b1a",
	"./fr/SDG-7.svg": "b9e1",
	"./fr/SDG-8.svg": "2683",
	"./fr/SDG-9.svg": "0798"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "34db";